import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ROLE_HIERARCHY = ['superadmin', 'admin', 'editor', 'viewer', 'attendance', 'transportation'];

const ATTENDANCE_ALLOWED_PATHS = ['/attendance', '/mfa/setup', '/mfa/verify'];
const TRANSPORTATION_ALLOWED_PATHS = ['/transportation', '/mfa/setup', '/mfa/verify'];

const PrivateRoute = ({ children, requiredRole, skipMfaCheck }) => {
  const { user, loading, mfaRequired } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (!skipMfaCheck && mfaRequired) {
    return <Navigate to="/mfa/verify" />;
  }

  if (user.role === 'attendance') {
    const isAllowed = ATTENDANCE_ALLOWED_PATHS.some(p => location.pathname.startsWith(p));
    if (!isAllowed) {
      return <Navigate to="/attendance" />;
    }
  }

  if (user.role === 'transportation') {
    const isAllowed = TRANSPORTATION_ALLOWED_PATHS.some(p => location.pathname.startsWith(p));
    if (!isAllowed) {
      return <Navigate to="/transportation" />;
    }
  }

  if (requiredRole) {
    const requiredIdx = ROLE_HIERARCHY.indexOf(requiredRole);
    const userIdx = ROLE_HIERARCHY.indexOf(user.role);
    if (userIdx < 0 || userIdx > requiredIdx) {
      return <Navigate to="/" />;
    }
  }

  return children;
};

export default PrivateRoute;
